module.exports = __webpack_public_path__ + "assets/img/VideoPlayerIcon.c77cc5db-ps.png";